jQuery( document ).ready(
	function( $ ) {
		//set button value
		$( '.vodia-country-code-select' ).each(
			function() {
				const $btn = $( this ).find( 'button' );
				const $defaultElement = $( this ).find( '[data-value=' + $btn.val() + ']' );
				$btn.html( $defaultElement.clone()[ 0 ] );
			}
		);

		$( '.vodia-country-code-select button' ).click(
			function() {
				$( this ).closest( '.vodia-country-code-select' ).find( '.options' ).show();
			}
		);

		$( '.vodia-country-code-select ul li' ).click(
			function() {
				const $btn = $( this ).closest( '.vodia-country-code-select' ).find( 'button' );
				$btn.val( $( this ).data( 'value' ) );
				$( this ).closest( '.vodia-country-code-select' ).find( 'input' ).val( $( this ).data( 'value' ) );
				$btn.html( $( this ).clone()[ 0 ] );
				$( this ).closest( '.vodia-country-code-select' ).find( '.options' ).hide();
			}
		);

		$( document ).on( 'click', function( e ) {
			// If the target is not the container or a child of the container, then process
			// the click event for outside of the container.
			if ( $( e.target ).closest( '.vodia-country-code-select' ).length === 0 ) {
				$( '.vodia-country-code-select' ).find( '.options' ).hide();
			}
		} );
	}
);
